module.exports = __webpack_public_path__ + "static/media/codeSendBg.75d57dac.jpeg";